import { Injectable } from '@angular/core';

export type StyleConfig = {

  mainColor?: string;
  mainColorTransparent?: string;
  mainColorVeryTransparent?: string;
  mainColorLighter?: string;

  secondaryColor?: string;
  green?: string;
  black?: string;
  blue?: string;
  customWhite?: string;

  // Einzelne Material-Overrides 
  mat?: Record<string, string>;

  // Fallbacks 
  kunden_logo_name?: string;
  kunden_style_wert?: string;
  kunden_style_button?: string;
  kunden_style_text?: string;
};

@Injectable({ providedIn: 'root' })
export class StyleService {

  applyStyleConfig(cfg?: StyleConfig | null) {
    if (!cfg) return;
    const root = document.documentElement;

    // Fallbacks mappen
    // Primärfarbe
    const legacyPrimary = cfg.kunden_style_wert;
    // Buttonfarbe
    const legacyButton  = cfg.kunden_style_button;
    // Textfarbe
    const legacyText    = cfg.kunden_style_text;

    // Custom Properties setzen (inline auf :root -> überschreibt SCSS :root)
    this.set('--mainColor',              cfg.mainColor ?? legacyPrimary);
    this.set('--secondaryColor',         cfg.secondaryColor ?? legacyButton);

    this.set('--mainColorTransparent',   cfg.mainColorTransparent);
    this.set('--mainColorVeryTransparent', cfg.mainColorVeryTransparent);
    this.set('--mainColorLighter',       cfg.mainColorLighter);

    this.set('--green',                  cfg.green);
    this.set('--black',                  cfg.black ?? legacyText);
    this.set('--blue',                   cfg.blue);
    this.set('--customWhite',            cfg.customWhite);

    if (cfg.mainColor) {
      this.set('--sys-primary', cfg.mainColor);
    }

    // optionale zusätzliche Variablen
    if (cfg.mat) {
      Object.entries(cfg.mat).forEach(([k, v]) => {
        if (v) this.set(`--${k}`, v);
      });
    }
  }

  private set(name: string, value?: string) {
    if (!value) return;
    document.documentElement.style.setProperty(name, value);
  }
}
